import ResetPassword from 'pages/updatePassword/ResetPassword';
import NotFound from 'components/NotFound';
import AccessDenied from 'components/403';
import { Navigate } from 'react-router-dom';
import Error from 'components/Error';

const ResetRoute = {
  path: '/',
  children: [
    {
      path: '/reset-password/:id',
      element: <ResetPassword />
    },
    {
      path: '404',
      element: <NotFound />
    },
    {
      path: '*',
      element: <Navigate to="/404" replace={true} />
    },
    {
      path: '403',
      element: <AccessDenied />
    },
    {
      path: 'Error',
      element: <Error />
    }
  ]
};

export default ResetRoute;
